import {handleError} from '../utils.js'

export const getInitialProps = async ({routeInfo, context: {domain, i18n}}) => {
  const {
    location: {state}
  } = routeInfo

  const config = domain.get('config')

  const {VEHICLE_SUGGESTER_PATH_PATTERN: homeSuggesterPath, VEHICLE_SUGGESTER_RESULTS_PAGE_NAME: pageName} =
    config.get('page')

  const [error, suggestedVehiclesResponse] = await domain.get('get_suggested_vehicles_use_case').execute({
    from: state?.priceRange?.from,
    to: state?.priceRange?.to,
    bodyTypeIds: state?.bodyTypeIds,
    fuelTypeIds: state?.fuelTypeIds,
    seats: state?.seats,
    makeIds: state?.makes
  })

  if (error) {
    return handleError({
      domain,
      i18n,
      error,
      message: 'Error fetching suggested vehicles',
      redirectTo: homeSuggesterPath
    })
  }

  const suggestions = suggestedVehiclesResponse?.value?.suggestions || []

  return {
    h1: i18n.t('VEHICLE_SUGGESTER.RESULTS.TITLE'),
    pageName,
    suggestions: suggestions || []
  }
}
